/**
 * @class Oskari.mapframework.bundle.search.Flyout
 *
 * Renders the "search" flyout.
 */
Oskari.clazz.define('Oskari.mapframework.bundle.search.Flyout',
/**
 * @method create called automatically on construction
 * @static
 * @param {Oskari.mapframework.bundle.search.SearchBundleInstance}
 *        instance reference to component that created the tile
 */
function (instance) {
  this.instance = instance;
  this.container = '#panel-right div.search';
  this.state = null;
  this.template = null;
  this.templateResultTable = null;
  this.templateResultTableHeader = null;
  this.templateResultTableRow = null;
  this.resultHeaders = [];
  // last search result is saved so we can sort it in client
  this.lastResult = null;
  // last sort parameters are saved so we can change sort direction
  // if the same column is sorted again
  this.lastSort = null;
  this.svg = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" id="CustomMarker"><path  d="M26.3 11.3C26.3 5.6 21.7 1 16 1 10.3 1 5.7 5.6 5.7 11.3c0 2 .6 3.8 1.5 5.4L16 31l8.9-14.3c.9-1.5 1.4-3.4 1.4-5.4z" fill="#0557d3"/><circle cx="16" cy="11.2" r="4.1" fill="#fff"/></svg>';
  this._searchContainer = null;
}, {
  /**
   * @method getName
   * @return {String} the name for the component
   */
  getName: function getName() {
    return 'Oskari.mapframework.bundle.search.Flyout';
  },
  /**
   * @method setEl
   * @param {Object} el
   * 		reference to the container in browser
   * @param {Number} width
   * 		container size(?) - not used
   * @param {Number} height
   * 		container size(?) - not used
   *
   * Interface method implementation
   */
  setEl: function setEl(el, width, height) {
    //this.container = el[0];
    //if (!jQuery(this.container).hasClass('search')) {
    //    jQuery(this.container).addClass('search');
    //}
  },
  /**
   * @method startPlugin
   *
   * Interface method implementation, assigns the HTML templates
   * that will be used to create the UI
   */
  startPlugin: function startPlugin() {
    this.template = jQuery('<div class="searchContainer">' + '<div class="searchDescription" style="display:none"></div>' + '<div class="controls">' + '</div>' + '<div style="clear:both"><br></div>' + '<div class="info"></div>' + '<div><br></div>' + '<div class="resultList"></div>' + '</div>');
    this.templateResultTable = jQuery('<table class="search_result">' + '<thead><tr></tr></thead>' + '<tbody></tbody>' + '</table>');
    this.templateResultTableHeader = jQuery('<th><a href="JavaScript:void(0);"></a></th>');
    this.templateResultTableRow = jQuery('<tr>' + '<td><a href="JavaScript:void(0);"></a></td>' + '<td></td>' + '<td></td>' + '</tr>');
    this.resultHeaders = [{
      title: Oskari.getMsg('Search', 'grid.name'),
      prop: 'name'
    }, {
      title: Oskari.getMsg('Search', 'grid.region'),
      prop: 'region'
    }, {
      title: Oskari.getMsg('Search', 'grid.type'),
      prop: 'type'
    }];
  },
  /**
   * @method stopPlugin
   *
   * Interface method implementation, does nothing atm
   */
  stopPlugin: function stopPlugin() {},
  /**
   * @method getTitle
   * @return {String} localized text for the title of the flyout
   */
  getTitle: function getTitle() {
    return Oskari.getMsg('Search', 'title');
  },
  /**
   * @method getDescription
   * @return {String} localized text for the description of the
   * flyout
   */
  getDescription: function getDescription() {
    return Oskari.getMsg('Search', 'desc');
  },
  /**
   * @method getOptions
   * Interface method implementation, does nothing atm
   */
  getOptions: function getOptions() {},
  /**
   * @method setState
   * @param {Object} state
   */
  setState: function setState(state) {
    this.state = state;
  },
  /**
   * @method getState
   * @return {Object} state
   */
  getState: function getState() {
    if (!this.state) {
      return {};
    }
    return this.state;
  },
  /**
   * @method createUi
   * Creates the UI for a fresh start
   */
  createUi: function createUi() {
    var me = this;
    var sandbox = me.instance.getSandbox();
    var flyout = jQuery(this.container);
    flyout.empty();
    var searchContainer = this.template.clone();
    this._searchContainer = searchContainer;
    var searchDescription = searchContainer.find('div.searchDescription');
    searchDescription.html(Oskari.getMsg('Search', 'searchDescription'));
    var field = Oskari.clazz.create('Oskari.userinterface.component.FormInput');
    field.bindChange(function (event) {
      if (me.state === null) {
        me.state = {};
      }
      var value = field.getValue();
      me.state.searchtext = value;
      if (!value) {
        // remove results when field is emptied
        var info = searchContainer.find('div.info');
        info.empty();
        var resultList = searchContainer.find('div.resultList');
        resultList.empty();

        // try to remove markers if request is available when field is emptied
        var reqBuilder = Oskari.requestBuilder('MapModulePlugin.RemoveMarkersRequest');
        //                if(reqBuilder) {
        sandbox.request(me.instance.getName(), reqBuilder());
        //              }        
      }
    });
    field.addClearButton();
    var button = Oskari.clazz.create('Oskari.userinterface.component.Button');
    button.setTitle(Oskari.getMsg('Search', 'searchButton'));
    var doSearch = function doSearch() {
      field.setEnabled(false);
      button.setEnabled(false);
      var resultList = searchContainer.find('div.resultList');
      resultList.empty();
      var info = searchContainer.find('div.info');
      info.empty();

      // TODO: make some gif go round and round so user knows
      // something is happening
      var searchKey = field.getValue(false);
      me.instance.service.doSearch(searchKey, function (data) {
        field.setEnabled(true);
        button.setEnabled(true);
        me._renderResults(data, searchKey);
      }, function (data) {
        field.setEnabled(true);
        button.setEnabled(true);
        var dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup');
        var okBtn = dialog.createCloseButton('OK');
        var msg = Oskari.getMsg('Search', 'searchservice_search_alert_title');
        dialog.show(msg, msg, [okBtn]);
      });
    };
    button.setHandler(doSearch);
    field.bindEnterKey(doSearch);
    var controls = searchContainer.find('div.controls');
    controls.append(field.getField());
    controls.append(button.getElement());
    flyout.append(searchContainer);
  },
  _renderResults: function _renderResults(result, searchKey) {
    if (!result || typeof result.totalCount != 'number') {
      return;
    }
    var resultList = this._searchContainer.find('div.resultList');
    resultList.empty();
    this.lastResult = result;
    var me = this;
    var info = this._searchContainer.find('div.info');
    info.empty();
    var inst = this.instance;
    // error handling
    if (result.totalCount == -1) {
      resultList.append(Oskari.getMsg('Search', 'searchservice_search_alert_title') + Oskari.getMsg('Search', 'result.errorText'));
      return;
    } else if (result.totalCount == 0) {
      resultList.append(Oskari.getMsg('Search', 'searchservice_search_not_found_anything_text'));
      return;
    } else {
      info.append(Oskari.getMsg('Search', 'searchResultCount') + result.totalCount + Oskari.getMsg('Search', 'searchResultCount2'));
      info.append('<br/>');
      if (result.hasMore) {
        // more results available
        info.append(Oskari.getMsg('Search', 'searchResultDescriptionMoreResults'));
        info.append('<br/>');
      }
      info.append(Oskari.getMsg('Search', 'searchResultDescriptionOrdering'));
    }
    if (result.totalCount == 1) {
      // move map etc
      me._resultClicked(result.locations[0]);
      // close flyout
      inst.sandbox.postRequestByName('userinterface.UpdateExtensionRequest', [me.instance, 'close']);
    }
    // render results
    var table = this.templateResultTable.clone();
    var tableHeaderRow = table.find('thead tr');
    var tableBody = table.find('tbody');
    // header reference needs some closure magic to work here

    var headerClosureMagic = function headerClosureMagic(scopedValue) {
      return function () {
        // clear table for sorted results
        tableBody.empty();
        // default to descending sort
        var descending = false;
        // if last sort was made on the same column ->
        // change direction
        if (me.lastSort && me.lastSort.attr == scopedValue.prop) {
          descending = !me.lastSort.descending;
        }
        // sort the results
        me._sortResults(scopedValue.prop, descending);
        // populate table content
        me._populateResultTable(tableBody);
        // apply visual changes
        var headerContainer = tableHeaderRow.find('a:contains(' + scopedValue.title + ')');
        tableHeaderRow.find('th').removeClass('asc');
        tableHeaderRow.find('th').removeClass('desc');
        if (descending) {
          headerContainer.parent().addClass('desc');
        } else {
          headerContainer.parent().addClass('asc');
        }
        return false;
      };
    };
    for (var i = 0; i < this.resultHeaders.length; ++i) {
      var header = this.templateResultTableHeader.clone();
      var link = header.find('a');
      link.append(this.resultHeaders[i].title);
      link.bind('click', headerClosureMagic(this.resultHeaders[i]));
      tableHeaderRow.append(header);
    }
    this._populateResultTable(tableBody);
    resultList.append('<div><h3>' + Oskari.getMsg('Search', 'searchResults') + result.totalCount + Oskari.getMsg('Search', 'searchResultsDescription') + searchKey + '</h3></div>');
    resultList.append(table);
  },
  _populateResultTable: function _populateResultTable(resultsTableBody) {
    var me = this;
    // row reference needs some closure magic to work here
    var closureMagic = function closureMagic(scopedValue) {
      return function () {
        me._resultClicked(scopedValue);
        return false;
      };
    };
    var locations = this.lastResult.locations;
    for (var i = 0; i < locations.length; ++i) {
      var row = locations[i];
      var resultContainer = this.templateResultTableRow.clone();
      var cells = resultContainer.find('td');
      var titleCell = jQuery(cells[0]);
      var title = titleCell.find('a');
      title.append(row.name);
      title.bind('click', closureMagic(row));
      jQuery(cells[1]).append(row.region);
      jQuery(cells[2]).append(row.type);
      resultsTableBody.append(resultContainer);
    }
  },
  _resultClicked: function _resultClicked(result) {
    var me = this;
    var popupId = "searchResultPopup";
    var inst = this.instance;
    var sandbox = inst.sandbox;
    // good to go
    // Remove old markers
    var reqBuilder = Oskari.requestBuilder('MapModulePlugin.RemoveMarkersRequest');
    if (reqBuilder) {
      sandbox.request(me.instance.getName(), reqBuilder());
    }
    // Add new marker
    reqBuilder = Oskari.requestBuilder('MapModulePlugin.AddMarkerRequest');
    if (reqBuilder) {
      sandbox.request(me.instance.getName(), reqBuilder({
        color: 'ffde00',
        msg: result.name,
        shape: me.svg,
        size: 2,
        x: result.lon,
        y: result.lat
      }));
    }
    var moveReqBuilder = Oskari.requestBuilder('MapMoveRequest');
    sandbox.request(me.instance.getName(), moveReqBuilder(result.lon, result.lat, result.zoomLevel, false));
    var loc = Oskari.getMsg('Search', 'resultBox');
    var contentItem = {
      html: "<h3>" + result.name + "</h3>" + "<p>" + result.region + '<br/>' + result.type + "</p>",
      actions: {}
    };
    /*        var content = [contentItem];
    
    		 impl smashes action key to UI - we'll have to localize that here */
    //       contentItem.actions[loc['close']] = function() {
    //                 var rN = 'InfoBox.HideInfoBoxRequest';
    //               var rB = Oskari.requestBuilder(rN);
    //             var request = rB(popupId);
    //           sandbox.request(me.instance.getName(), request);
    //        };

    //var rN = 'InfoBox.ShowInfoBoxRequest';
    //        var rB = Oskari.requestBuilder(rN);
    //        var request = rB(popupId, loc['title'], content, new OpenLayers.LonLat(result.lon, result.lat), true);
    //      sandbox.request(this.instance.getName(), request);
  },
  /**
   * @method _sortResults
   * Sorts the last search result by comparing given attribute on
   * the search objects
   * @private
   * @param {String} pAttribute attributename to sort by (e.g.
   * result[pAttribute])
   * @param {Boolean} pDescending true if sort direction is descending
   */
  _sortResults: function _sortResults(pAttribute, pDescending) {
    var me = this;
    if (!this.lastResult) {
      return;
    }
    this.lastSort = {
      attr: pAttribute,
      descending: pDescending
    };
    this.lastResult.locations.sort(function (a, b) {
      return me._searchResultComparator(a, b, pAttribute, pDescending);
    });
  },
  /**
   * @method _searchResultComparator
   * Compares the given attribute on given objects for sorting
   * search result objects.
   * @private
   * @param {Object} a search result 1
   * @param {Object} b search result 2
   * @param {String} pAttribute attributename to sort by (e.g.
   * a[pAttribute])
   * @param {Boolean} pDescending true if sort direction is descending
   */
  _searchResultComparator: function _searchResultComparator(a, b, pAttribute, pDescending) {
    var nameA = a[pAttribute].toLowerCase();
    var nameB = b[pAttribute].toLowerCase();
    var value = 0;
    if (nameA == nameB || 'name' == pAttribute) {
      // Because problem with address 1 and address 10 then
      // id are ranked right
      nameA = a.id;
      nameB = b.id;
    }
    if (nameA < nameB) {
      value = -1;
    } else if (nameA > nameB) {
      value = 1;
    }
    if (pDescending) {
      value = value * -1;
    }
    return value;
  }
}, {
  /**
   * @property {String[]} protocol
   * @static
   */
  'protocol': ['Oskari.userinterface.Flyout']
});